import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'pgsDate'
})
export class PgsDatePipe implements PipeTransform {
  public transform(value: Date | string, ...args: unknown[]): unknown {
    const formattedDate = moment(value, 'DD-MM-YYYY HH:mm:ss').format('DD/MM/YYYY');
    return formattedDate === 'Invalid date' ? 'Fecha invalida' : formattedDate;
  }
}
